// import React from "react"

// import { OutlinedInput } from "@material-ui/core";

// const CustomNumberInputField = (props) => {
//     const { classes, element, dataObj, onChange, styles, selectedStep, inputClasses } = props
//     return (
//         <OutlinedInput
//             id={`${element.name}`}
//             variant="outlined"
//             // className={classes.inputField}
//             // style = {styles ? styles : {}}
//             required={element.required}
//             key={element.value || element.name}
//             name={element.value || element.name}
//             disabled={element.readOnly}
//             type={'number'}
            // style={{
            //     width: "100%",
            //     height: "32px",
            //     padding: '5px 8px 6px 8px'
            // }}
            // classes={{
            //     root: inputClasses?.smallOutlinedInput,
            //     notchedOutline: inputClasses?.smallNotchedOutline,
            // }}
//             value={(dataObj[element.value] || dataObj[element.name])}
//             title={(dataObj[element.value] || dataObj[element.name])}
//             onChange={(e) => {
//                 onChange((element.value || element.name), e.target.value, element.type);
//             }}
//         />
//     )
// }

// export default CustomNumberInputField

import React, { useState } from "react";
import { OutlinedInput, InputAdornment } from "@material-ui/core";

const formatCurrency = (value, showDollarSymbol = false, showPoundSymbol = false, showPercentageIcon = false) => {
    if (value == null || value === '') {
        // Show 0.00 with currency symbol when value is empty
        if (showDollarSymbol) {
            return '$0.00';
        } else if (showPoundSymbol) {
            return '£0.00';
        } else if (showPercentageIcon) {
            return '0.0%';
        }
        return '0.00';
    }
    
    const number = Number(value);
    if (isNaN(number)) return value;
    
    // For percentage, format to exactly 1 decimal place
    if (showPercentageIcon) {
        return `${number.toFixed(1)}%`;
    }
    
    // Format with 2 decimal places for currency
    const formattedNumber = number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    
    // Add currency symbol based on props
    if (showDollarSymbol) {
        return `$${formattedNumber}`;
    } else if (showPoundSymbol) {
        return `£${formattedNumber}`;
    }
    
    return formattedNumber;
};

const CustomNumberInputField = (props) => {
    const { classes, element, dataObj, onChange, styles, inputClasses } = props;

    const key = element.value || element.name;
    const rawValue = dataObj[key] ?? '';
    const [isEditing, setIsEditing] = useState(false);
    const [inputValue, setInputValue] = useState(rawValue);

    const handleFocus = () => {
        setIsEditing(true);
        // Remove formatting when entering edit mode
        const numericValue = rawValue.toString().replace(/[^0-9.-]/g, '');
        setInputValue(numericValue);
    };

    const handleBlur = () => {
        setIsEditing(false);
        // Format the value when leaving edit mode
        let numericValue = parseFloat(inputValue) || 0;
        onChange(key, numericValue, element.type);
    };

    const handleChange = (e) => {
        let val = e.target.value;
        // Allow only numbers, decimal point, and minus sign
        val = val.replace(/[^0-9.-]/g, '');
        // Ensure only one decimal point
        const parts = val.split('.');
        if (parts.length > 2) {
            val = parts[0] + '.' + parts.slice(1).join('');
        }
        setInputValue(val);
    };

    const valueToDisplay = () => {
        if (isEditing) {
            return inputValue;
        } else {
            return formatCurrency(rawValue, element.showDollarSymbol, element.showPoundSymbol, element.showPercentageIcon);
        }
    };

    const getIcon = () => {
        if (element.showIcon) {
            if (element.showDollarSymbol) {
                return '$';
            } else if (element.showPoundSymbol) {
                return '£';
            } else if (element.showPercentageIcon) {
                return '%';
            } else {
                return '₹'; // Default icon if no specific currency symbol
            }
        }
        return null;
    };

    return (
        <OutlinedInput
            id={element.name}
            variant="outlined"
            required={element.required}
            key={key}
            style={{
                width: "100%",
                height: "32px",
                padding: '5px 8px 6px 8px'
            }}
            classes={{
                root: inputClasses?.smallOutlinedInput,
                notchedOutline: inputClasses?.smallNotchedOutline,
            }}
            name={key}
            disabled={element.readOnly}
            type="text"
            value={valueToDisplay()}
            title={valueToDisplay()}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
        />
    );
};

export default CustomNumberInputField;